import React from 'react';
import type { IconProps } from '../types';

export const IconShield: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M10 2.5L16.5 5V9.5C16.5 13.6421 13.6421 16.5 10 17.5C6.35786 16.5 3.5 13.6421 3.5 9.5V5L10 2.5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

